<app-dynamic-modal-form
  size="lg"
  [actions]="[{label: 'Accepter la demande', class: 'btn-primary', icon: 'check'}]"
  [generator]="partialRequestFormGeneratorService"
  (onSubmit)="onSubmit($event)"
  (onCancel)="onCancel()"
  [title]="'Validation partielle de la demande ' + (request && request.requestType === 'EDIT' ? 'de modification' : 'd\'ajout') + ' d\'utilisateur'"
  [object]="request">
  <ng-template let-object="object">
    @if((object.products | keyvalue).length > 0 ) {
      <div class="pb-3 pt-3">
        <p class="fw-bold">Sélectionner le(s) produit(s) accepté(s) :</p>
        <div class="d-flex flex-column">
          @for (p of object.products | keyvalue; track p) {
            <div>
              @if (getCategoryFromSlug(p.key); as cat) {
                <label
                  class="d-flex grid-gap-05rem align-items-center cursor-pointer">
                  <input [(ngModel)]="p.value.accepted" type="checkbox"/>
                  <app-badge
                  [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
                </label>
              }
            </div>
          }
        </div>
      </div>
    }
    <div>
      @if(object.requestType === 'ADD') {
        <p>Avant de valider la demande d'ajout d'utilisateur, s'assurer que :</p>
        <ul>
          <li>L'utilisateur a été créé sur CremeCRM</li>
          <li>Celui-ci est rattaché au compte client <a
          [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DAccounts%26action%3DDetailView%26record%3D' + object.contact.account.crmId">{{ object.contact.account.name }}</a>
        </li>
        @if(object.profile.profile.toLowerCase() === 'referent') {
          <li>La case "référent" est cochée sur l'utilisateur CremeCRM</li>
        }
        <li>Celui-ci est (éventuellement) rattaché aux contrats produits
          @for(p of object.products | keyvalue; track p) {
            <span>
              @if(getCategoryFromSlug(p.key); as cat) {
                <app-badge [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
              }
            </span>
          }
        </li>
      </ul>
    }
    <p class="text-info">
      <fa-icon icon="info-circle"></fa-icon>
      En validant ce formulaire, un mail de confirmation sera envoyé automatiquement au demandeur et au nouvel
      utilisateur.
    </p>
  </div>
  <div class="pt-3">
    <h2>Rappel de la demande</h2>
    <hr/>
    @if(object.requestType === 'EDIT') {
      <app-user-request-comparator [asAdmin]="true" [request]="object"
      [user]="object.forContact"></app-user-request-comparator>
    } @else {
      <app-user-request-detail [request]="object" [categories]="categories" [crmUrl]="crmUrl"></app-user-request-detail>
    }
  </div>
</ng-template>
</app-dynamic-modal-form>
